import graphql from 'babel-plugin-relay/macro';
import { useMutation } from 'react-relay';

import { DeleteParticipantMutation } from './__generated__/DeleteParticipantMutation.graphql';

const deleteParticipantMutation = graphql`
  mutation DeleteParticipantMutation($id: ID!) {
    deleteParticipant(id: $id) {
      id @deleteRecord
    }
  }
`;

const useDeleteParticipantMutation = () =>
  useMutation<DeleteParticipantMutation>(deleteParticipantMutation);

export { useDeleteParticipantMutation };
